export const translations = {
  fr: {
    // Nav
    "nav.dashboard": "Tableau de bord",
    "nav.play": "Jouer",
    "nav.history": "Historique",
    "nav.leaderboards": "Classements",
    "nav.stats": "Statistiques",
    "nav.rewards": "Récompenses",
    "nav.notifications": "Notifications",
    "nav.profile": "Profil",
    "nav.admin": "Administration",
    "nav.logout": "Déconnexion",
    "nav.login": "Connexion",
    "nav.register": "Créer un compte",

    // Landing
    "landing.tagline": "Le Jeu de l'",
    "landing.taglineAccent": "Émergence",
    "landing.subtitle": "Une plateforme de jeu de stratégie linguistique — pour apprendre, s'affronter et faire émerger le meilleur de chaque esprit.",
    "landing.cta.primary": "Commencer à jouer",
    "landing.cta.secondary": "Découvrir la plateforme",
    "landing.feature.play.title": "Duels en temps réel",
    "landing.feature.play.body": "Affrontez d'autres joueurs sur un plateau 10×10 avec chronomètre 40 secondes.",
    "landing.feature.learn.title": "Apprentissage vivant",
    "landing.feature.learn.body": "Vocabulaire, calcul, stratégie — pour élèves, étudiants et familles.",
    "landing.feature.rank.title": "Classements officiels",
    "landing.feature.rank.body": "Global, hebdo, mensuel, annuel, par école, université ou organisation.",
    "landing.feature.rewards.title": "Récompenses & progression",
    "landing.feature.rewards.body": "Badges, trophées, niveaux d'XP — reconnaissez chaque étape franchie.",
    "landing.about.title": "Pensé pour l'écosystème éducatif",
    "landing.about.body": "Globo est développé par CBC Global Holdings Ltd pour équiper écoles, universités et clubs d'un outil ludique et rigoureux.",

    // Auth
    "auth.login.title": "Connexion",
    "auth.login.subtitle": "Reprenez la partie là où vous l'avez laissée.",
    "auth.register.title": "Créer un compte",
    "auth.register.subtitle": "Rejoignez la communauté Globo.",
    "auth.email": "Adresse e-mail",
    "auth.password": "Mot de passe",
    "auth.name": "Nom complet",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.orContinue": "ou continuer avec",
    "auth.google": "Continuer avec Google",
    "auth.submit.login": "Se connecter",
    "auth.submit.register": "Créer mon compte",
    "auth.noAccount": "Pas encore de compte ?",
    "auth.hasAccount": "Déjà membre ?",
    "auth.forgot.title": "Réinitialiser le mot de passe",
    "auth.forgot.subtitle": "Recevez un lien de réinitialisation par e-mail.",
    "auth.forgot.submit": "Envoyer le lien",
    "auth.forgot.back": "Retour à la connexion",
    "auth.reset.title": "Nouveau mot de passe",
    "auth.reset.submit": "Mettre à jour",

    // Auth errors (mapped from backend {code} or client-side conditions)
    "auth.err.generic": "Une erreur est survenue. Veuillez réessayer.",
    "auth.err.network_error": "Impossible de contacter le serveur. Vérifiez votre connexion.",
    "auth.err.server_error": "Erreur serveur. Réessayez dans quelques instants.",
    "auth.err.unauthorized": "Session expirée. Veuillez vous reconnecter.",
    "auth.err.forbidden": "Accès refusé.",
    "auth.err.invalid_credentials": "E-mail ou mot de passe incorrect.",
    "auth.err.email_in_use": "Cet e-mail est déjà utilisé. Essayez de vous connecter.",
    "auth.err.too_many_attempts": "Trop de tentatives échouées. Réessayez dans 15 minutes.",
    "auth.err.invalid_email_format": "Adresse e-mail invalide. Utilisez un domaine valide (ex: gmail.com).",
    "auth.err.validation_error": "Certains champs sont invalides. Vérifiez et réessayez.",
    "auth.err.missing_refresh_token": "Session expirée. Veuillez vous reconnecter.",
    "auth.err.invalid_token": "Session invalide. Veuillez vous reconnecter.",
    "auth.err.user_not_found": "Compte introuvable.",
    "auth.err.invalid_reset_token": "Lien de réinitialisation invalide ou déjà utilisé.",
    "auth.err.reset_token_expired": "Ce lien de réinitialisation a expiré.",
    "auth.err.no_password_set": "Ce compte utilise Google. Connectez-vous avec Google.",
    "auth.err.wrong_current_password": "Mot de passe actuel incorrect.",
    "auth.err.invalid_google_session": "La session Google est invalide ou expirée.",
    "auth.success.login": "Connexion réussie.",
    "auth.success.register": "Compte créé avec succès.",

    // Dashboard
    "dashboard.hello": "Bonjour",
    "dashboard.stats.games": "Parties jouées",
    "dashboard.stats.wins": "Victoires",
    "dashboard.stats.best": "Meilleur score",
    "dashboard.stats.avg": "Score moyen",
    "dashboard.recent": "Parties récentes",
    "dashboard.leaderboard": "Classement mondial",
    "dashboard.actions.play": "Nouvelle partie",
    "dashboard.actions.join": "Rejoindre une partie",
    "dashboard.progress": "Progression",
    "dashboard.level": "Niveau",
    "dashboard.xp": "Points d'expérience",
    "dashboard.noGames": "Aucune partie encore. Commencez votre première !",

    // Lobby
    "lobby.title": "Salle d'attente",
    "lobby.subtitle": "Créez une partie ou rejoignez-en une.",
    "lobby.create.title": "Créer une partie",
    "lobby.create.public": "Publique",
    "lobby.create.private": "Privée (avec code)",
    "lobby.create.language": "Langue",
    "lobby.create.button": "Créer",
    "lobby.open": "Parties ouvertes",
    "lobby.join": "Rejoindre",
    "lobby.joinCode": "Code d'invitation",
    "lobby.joinCode.button": "Rejoindre par code",
    "lobby.bot.title": "Jouer contre Coach Globo",
    "lobby.bot.difficulty": "Difficulté",
    "lobby.bot.easy": "Facile",
    "lobby.bot.medium": "Moyen",
    "lobby.bot.hard": "Difficile",
    "lobby.bot.start": "Démarrer contre le bot",

    // Game
    "game.turn": "À vous de jouer",
    "game.opponent": "Tour de l'adversaire",
    "game.waiting": "En attente d'un adversaire...",
    "game.invite": "Code d'invitation",
    "game.pass": "Passer",
    "game.play": "Jouer le mot",
    "game.exchange": "Échanger",
    "game.forfeit": "Abandonner",
    "game.recall": "Rappeler les lettres",
    "game.shuffle": "Mélanger",
    "game.bag": "Sac",
    "game.score": "Score",
    "game.over": "Partie terminée",
    "game.winner": "Vainqueur",
    "game.draw": "Match nul",
    "game.forfeitConfirm": "Confirmer l'abandon ?",

    // History
    "history.title": "Historique des parties",
    "history.empty": "Aucune partie dans votre historique.",
    "history.date": "Date",
    "history.opponent": "Adversaire",
    "history.result": "Résultat",
    "history.score": "Score",
    "history.won": "Victoire",
    "history.lost": "Défaite",
    "history.draw": "Nul",
    "history.abandoned": "Abandon",

    // Leaderboards
    "lb.title": "Classements",
    "lb.period.all": "Tout",
    "lb.period.week": "Semaine",
    "lb.period.month": "Mois",
    "lb.period.year": "Année",
    "lb.scope.global": "Global",
    "lb.scope.org": "Organisation",
    "lb.scope.country": "Pays",
    "lb.rank": "Rang",
    "lb.player": "Joueur",
    "lb.wins": "Victoires",
    "lb.games": "Parties",
    "lb.best": "Meilleur",
    "lb.total": "Total",

    // Stats
    "stats.title": "Statistiques personnelles",
    "stats.progression": "Progression (10 dernières)",
    "stats.winRate": "Taux de victoire",

    // Rewards
    "rewards.title": "Récompenses",
    "rewards.subtitle": "Suivez votre progression et vos accomplissements.",
    "rewards.unlocked": "Débloqué",
    "rewards.locked": "Verrouillé",
    "rewards.progress": "Progression",

    // Profile
    "profile.title": "Profil & Paramètres",
    "profile.personal": "Informations personnelles",
    "profile.language": "Langue",
    "profile.theme": "Thème",
    "profile.theme.light": "Clair",
    "profile.theme.dark": "Sombre",
    "profile.theme.system": "Système",
    "profile.org": "Organisation / École",
    "profile.country": "Pays",
    "profile.save": "Enregistrer",
    "profile.password": "Sécurité",
    "profile.password.current": "Mot de passe actuel",
    "profile.password.new": "Nouveau mot de passe",
    "profile.password.update": "Mettre à jour",
    "profile.danger": "Zone sensible",
    "profile.delete": "Supprimer mon compte",
    "profile.deleteConfirm": "Supprimer définitivement votre compte ?",
    "profile.notif.enable": "Activer les notifications push",
    "profile.notif.test": "Envoyer une notification test",
    "profile.notif.denied": "Autorisation refusée par le navigateur",

    // Notifications
    "notif.title": "Notifications",
    "notif.empty": "Aucune notification.",
    "notif.markAllRead": "Tout marquer comme lu",

    // Admin
    "admin.title": "Administration",
    "admin.overview": "Vue d'ensemble",
    "admin.users": "Utilisateurs",
    "admin.games": "Parties",
    "admin.logs": "Journaux",
    "admin.announcement": "Annonce",
    "admin.settings": "Paramètres",
    "admin.broadcast": "Diffuser à tous",
    "admin.title.field": "Titre",
    "admin.body.field": "Message",
    "admin.send": "Envoyer",
    "admin.role": "Rôle",
    "admin.ban": "Bannir",
    "admin.delete": "Supprimer",
    "admin.turnSeconds": "Durée du tour (secondes)",
    "admin.save": "Enregistrer",

    "common.loading": "Chargement...",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.confirm": "Confirmer",
    "common.delete": "Supprimer",
    "common.close": "Fermer",
    "common.search": "Rechercher",
    "common.error": "Erreur",
    "common.success": "Succès",
    "common.optional": "Optionnel",
    "common.brand": "Globo",
    "common.brandLong": "Globo — Le Jeu de l'Émergence",
    "common.company": "CBC Global Holdings Ltd",
    "common.next": "Suivant",
    "common.prev": "Précédent",

    // Onboarding
    "onb.step1.title": "Bienvenue sur Globo",
    "onb.step1.body": "Globo — Le Jeu de l'Émergence est une plateforme éducative où chaque partie révèle un peu plus d'intelligence. Prenez 30 secondes pour découvrir comment jouer.",
    "onb.step2.title": "Un jeu, plusieurs bénéfices",
    "onb.step2.body": "Enrichissez votre vocabulaire, aiguisez votre stratégie et rivalisez avec des joueurs du monde entier — classements par école, université ou organisation.",
    "onb.step3.title": "Prêt à jouer ?",
    "onb.step3.body": "Choisissez votre point de départ. Vous pourrez revenir ici depuis le Centre d'aide à tout moment.",
    "onb.next": "Continuer",
    "onb.done": "C'est parti",
    "onb.cta.discover": "Découvrir Globo",
    "onb.cta.discoverBody": "Tutoriel interactif étape par étape",
    "onb.cta.demo": "Voir la démo",
    "onb.cta.demoBody": "Une partie automatique commentée",
    "onb.cta.play": "Jouer maintenant",
    "onb.cta.playBody": "Directement dans le grand bain",

    // Tutorial
    "tut.badge": "Tutoriel interactif",
    "tut.title": "Apprendre Globo",
    "tut.skip": "Passer",
    "tut.stepLabel": "Étape {n} / {total}",
    "tut.finish": "Terminer",
    "tut.step.board.title": "Le plateau officiel",
    "tut.step.board.body": "Le plateau Globo compte 9 colonnes et 6 rangées. Les 3 rangées du haut affichent l'alphabet à l'endroit ; les 3 du bas sont retournées à 180° pour que chaque joueur voit son côté à l'endroit.",
    "tut.step.letters.title": "Les lettres gravées",
    "tut.step.letters.body": "Chaque case porte une lettre imprimée. Ces lettres servent de repères visuels et d'indicateurs de bonus — la valeur d'une lettre dépend de sa fréquence (A, E, I = 1 point ; K, W, X = 10 points).",
    "tut.step.numbers.title": "Les nombres 1 à 9",
    "tut.step.numbers.body": "Sur les bords haut et bas, les colonnes sont numérotées de 1 à 9. Ces repères aident à décrire une position (« F6 », « C2 »…) et rappellent la valeur potentielle de chaque colonne.",
    "tut.step.zones.title": "La Zone d'Émergence",
    "tut.step.zones.body": "Au centre du plateau, la Zone d'Émergence — entourée en cyan — accorde des bonus de mots doublés. Chaque première partie commence obligatoirement en la traversant.",
    "tut.step.turn.title": "Un tour de jeu",
    "tut.step.turn.body": "À votre tour, vous avez 40 secondes pour poser un mot. Sélectionnez une lettre du chevalet puis cliquez sur une case du plateau. Essayez maintenant : posez le mot CAT au centre.",
    "tut.step.score.title": "Le calcul des scores",
    "tut.step.score.body": "Chaque lettre apporte sa valeur. Les cases TW/DW multiplient le mot, TL/DL multiplient une lettre. Utilisez vos 7 lettres d'un coup pour +50 points (Bingo) !",
    "tut.step.end.title": "Fin de partie",
    "tut.step.end.body": "La partie se termine quand un joueur vide son chevalet et que le sac est vide, ou après plusieurs passages consécutifs. Le vainqueur remporte des XP, débloque des badges et grimpe au classement.",
    "tut.action.placeCat": "Cliquez sur C, puis sur (2,3), puis A → (2,4), puis T → (2,5).",
    "tut.action.placedCount": "lettres posées",

    // Demo
    "demo.badge": "Démonstration",
    "demo.title": "Une partie en direct",
    "demo.progress": "Progression",
    "demo.lastMove": "Dernier coup joué",
    "demo.starting": "Début de la partie",
    "demo.intro": "Léa et Kofi s'affrontent. Regardez comment chaque coup s'enchaîne et rapporte des points.",
    "demo.play": "Lecture",
    "demo.pause": "Pause",
    "demo.next": "Suivant",
    "demo.back": "Précédent",
    "demo.restart": "Rejouer",
    "demo.done.title": "Vous avez tout suivi !",
    "demo.done.replay": "Revoir la démonstration",
    "demo.done.tutorial": "Faire le tutoriel",
    "demo.done.play": "Jouer une partie",

    // Coach Globo
    "coach.name": "Coach Globo",
    "coach.online": "En ligne",
    "coach.placeholder": "Posez votre question…",
    "coach.q.rules": "Les règles",
    "coach.q.scores": "Comment on marque ?",
    "coach.q.play": "Comment jouer ?",
    "coach.greet.default": "Bonjour {name} ! Je suis Coach Globo. Je vous accompagne pour maîtriser le jeu.",
    "coach.greet.dashboard": "Content de vous revoir {name}. Prêt·e pour une nouvelle partie ? Regardez vos statistiques ci-dessous.",
    "coach.greet.lobby": "Créez une partie publique, une partie privée avec un code, ou rejoignez un adversaire en attente.",
    "coach.greet.game": "C'est le moment de jouer ! Sélectionnez une lettre puis cliquez sur une case libre. Bonne partie.",
    "coach.greet.lb": "Voici les classements. Filtrez par période (semaine, mois, année) et par portée (organisation, pays).",
    "coach.greet.stats": "Vos statistiques personnelles s'affichent ici. Suivez votre progression sur les 10 dernières parties.",
    "coach.greet.rewards": "Chaque badge se débloque via une action : premier mot, 10 parties, 250+ points, etc.",
    "coach.greet.tutorial": "Suivons le tutoriel ensemble. Je reste disponible si vous avez besoin d'aide.",
    "coach.greet.demo": "Regardez cette partie fictive : chaque coup est commenté pour vous.",
    "coach.a.rules": "Chaque joueur place des lettres pour former un mot valide. Le mot doit toucher le centre au premier tour, puis se connecter à un mot existant. 40 secondes par tour.",
    "coach.a.scores": "Additionnez la valeur des lettres. Les cases spéciales multiplient un mot (TW/DW) ou une lettre (TL/DL). Un « Bingo » (7 lettres jouées) rapporte +50 points.",
    "coach.a.board": "Le plateau fait 9 colonnes × 6 rangées. Le centre est la Zone d'Émergence — obligatoire pour le premier coup.",
    "coach.a.blank": "Le joker (?) vaut 0 point mais peut représenter n'importe quelle lettre. Vous choisissez laquelle en le posant.",
    "coach.a.bonus": "La Zone d'Émergence au centre accorde un bonus mot doublé au premier coup. Les autres cases spéciales sont réparties symétriquement.",
    "coach.a.rewards": "Chaque badge marque une étape. Ils apparaissent dans la section Récompenses. Les XP montent votre niveau.",
    "coach.a.timer": "Chaque tour dure 40 secondes. Passé ce temps, le tour est automatiquement passé.",
    "coach.a.pass": "Vous pouvez passer votre tour à tout moment. Si les deux joueurs passent 2 fois de suite, la partie se termine.",
    "coach.a.pwa": "Vous pouvez installer Globo comme une application. Cherchez l'option « Installer l'application » dans votre navigateur.",
    "coach.a.default": "Je suis là pour vous guider. Essayez : « Comment jouer ? », « Comment marquer ? », ou allez au Centre d'aide.",

    // Help Center
    "help.badge": "Centre d'aide",
    "help.title": "Comment pouvons-nous vous aider ?",
    "help.subtitle": "Toutes les réponses pour bien débuter et progresser sur Globo.",
    "help.searchPlaceholder": "Chercher une règle, un conseil, une question…",
    "help.quick.tutorial": "Tutoriel",
    "help.quick.demo": "Démo",
    "help.quick.play": "Jouer",
    "help.quick.coach": "Coach Globo",
    "help.section.rules": "Règles du jeu",
    "help.section.scoring": "Calcul des scores",
    "help.section.faq": "Questions fréquentes",
    "help.rules.q1": "Comment démarrer une partie ?",
    "help.rules.a1": "Depuis le menu Jouer, créez une partie publique ou privée. Une fois qu'un adversaire vous rejoint, la partie commence automatiquement.",
    "help.rules.q2": "Le premier mot doit-il toucher le centre ?",
    "help.rules.a2": "Oui. Au premier coup, une des lettres posées doit occuper la case centrale (Zone d'Émergence).",
    "help.rules.q3": "Combien de temps ai-je pour jouer ?",
    "help.rules.a3": "Vous avez 40 secondes par tour. Passé ce délai, le système passe automatiquement votre tour.",
    "help.rules.q4": "Puis-je échanger des lettres ?",
    "help.rules.a4": "Oui, si le sac contient assez de lettres. L'échange compte comme un tour passé.",
    "help.rules.q5": "Quand la partie se termine-t-elle ?",
    "help.rules.a5": "Quand un joueur vide son chevalet et que le sac est vide, ou après 4 passes consécutifs.",
    "help.scoring.q1": "Comment sont calculées les valeurs de lettres ?",
    "help.scoring.a1": "A, E, I, L, N, O, R, S, T, U valent 1 pt. D, G, M = 2. B, C, P = 3. F, H, V = 4. J, Q = 8. K, W, X, Y, Z = 10. Le joker vaut 0.",
    "help.scoring.q2": "Qu'est-ce qu'un bonus de case ?",
    "help.scoring.a2": "TW multiplie le mot × 3, DW × 2. TL multiplie une lettre × 3, DL × 2. Chaque bonus n'est appliqué qu'une seule fois (au moment de la pose).",
    "help.scoring.q3": "Qu'est-ce que le Bingo ?",
    "help.scoring.a3": "Si vous utilisez toutes vos 7 lettres en un seul coup, vous obtenez un bonus de +50 points.",
    "help.scoring.q4": "Les XP, comment ça marche ?",
    "help.scoring.a4": "Vous gagnez des XP à chaque partie : 30 XP de base + 1 XP tous les 10 points + 50 XP si victoire. Les XP montent votre niveau.",
    "help.faq.q1": "Puis-je installer Globo comme une application ?",
    "help.faq.a1": "Oui. Sur mobile ou desktop, cliquez sur « Installer Globo » quand la bannière apparaît, ou ajoutez la page à l'écran d'accueil depuis le menu du navigateur.",
    "help.faq.q2": "Est-ce que Globo fonctionne hors ligne ?",
    "help.faq.a2": "L'application est disponible en lecture hors ligne (dernier écran vu). Les parties actives nécessitent une connexion Internet.",
    "help.faq.q3": "Comment changer la langue ?",
    "help.faq.a3": "Cliquez sur le bouton FR/EN dans la barre supérieure, ou depuis votre profil.",
    "help.faq.q4": "Comment rejoindre le classement de mon école ?",
    "help.faq.a4": "Renseignez votre école ou université dans votre profil. Vous apparaîtrez automatiquement dans le classement de cette organisation.",
    "help.faq.q5": "Comment fonctionne le Coach Globo ?",
    "help.faq.a5": "Le Coach répond à vos questions sur les règles et vous guide selon la page consultée. Cliquez sur l'icône flottante en bas à droite.",

    // Post-game analysis
    "pg.title": "Analyse de partie",
    "pg.wordsPlayed": "Mots joués",
    "pg.bestWord": "Meilleur mot",
    "pg.avgPerWord": "Moyenne / mot",
    "pg.evolution": "Comparaison à votre moyenne",
    "pg.strengths": "Points forts",
    "pg.improve": "Axes d'amélioration",
    "pg.tip.longWords": "Cherchez des mots plus longs pour multiplier les bonus.",
    "pg.tip.center": "Passer par une Zone d'Émergence double votre score.",
    "pg.tip.bingo": "Utilisez vos 7 lettres pour +50 points de Bingo.",
    "pg.tip.regular": "Jouez régulièrement pour progresser au classement.",
    "pg.rematch": "Rejouer",
    "pg.share": "Partager",

    "nav.help": "Aide",
    "nav.tutorial": "Tutoriel",
    "nav.demo": "Démo",
    "assist.firstMove": "Premier coup : posez une lettre du chevalet sur la case centrale (W), puis complétez le mot autour.",
    "assist.selectTile": "Sélectionnez une lettre du chevalet en bas, puis cliquez sur une case libre.",
    "assist.playWord": "Cliquez sur « Jouer le mot » pour valider, ou « Rappeler » pour recommencer.",
    "assist.wait": "Patientez le temps que l'adversaire joue son coup.",
  },
  en: {
    "nav.dashboard": "Dashboard", "nav.play": "Play", "nav.history": "History",
    "nav.leaderboards": "Leaderboards", "nav.stats": "Stats", "nav.rewards": "Rewards",
    "nav.notifications": "Notifications", "nav.profile": "Profile", "nav.admin": "Admin",
    "nav.logout": "Sign out", "nav.login": "Sign in", "nav.register": "Create account",

    "landing.tagline": "The Game of ",
    "landing.taglineAccent": "Emergence",
    "landing.subtitle": "A linguistic strategy platform — to learn, compete and bring out the best of every mind.",
    "landing.cta.primary": "Start playing",
    "landing.cta.secondary": "Discover the platform",
    "landing.feature.play.title": "Real-time duels",
    "landing.feature.play.body": "Face other players on a 10×10 board with a 40-second turn timer.",
    "landing.feature.learn.title": "Living learning",
    "landing.feature.learn.body": "Vocabulary, arithmetic, strategy — for students, universities and families.",
    "landing.feature.rank.title": "Official rankings",
    "landing.feature.rank.body": "Global, weekly, monthly, yearly, per school, university or organization.",
    "landing.feature.rewards.title": "Rewards & progression",
    "landing.feature.rewards.body": "Badges, trophies, XP levels — celebrate every milestone.",
    "landing.about.title": "Built for the educational ecosystem",
    "landing.about.body": "Globo is developed by CBC Global Holdings Ltd to equip schools, universities and clubs with a playful yet rigorous tool.",

    "auth.login.title": "Sign in",
    "auth.login.subtitle": "Pick up your game where you left off.",
    "auth.register.title": "Create your account",
    "auth.register.subtitle": "Join the Globo community.",
    "auth.email": "Email", "auth.password": "Password", "auth.name": "Full name",
    "auth.forgot": "Forgot password?",
    "auth.orContinue": "or continue with",
    "auth.google": "Continue with Google",
    "auth.submit.login": "Sign in", "auth.submit.register": "Create account",
    "auth.noAccount": "No account yet?", "auth.hasAccount": "Already a member?",
    "auth.forgot.title": "Reset password",
    "auth.forgot.subtitle": "Receive a reset link by email.",
    "auth.forgot.submit": "Send link", "auth.forgot.back": "Back to sign in",
    "auth.reset.title": "New password", "auth.reset.submit": "Update",

    "auth.err.generic": "Something went wrong. Please try again.",
    "auth.err.network_error": "Cannot reach the server. Check your connection.",
    "auth.err.server_error": "Server error. Please retry in a moment.",
    "auth.err.unauthorized": "Session expired. Please sign in again.",
    "auth.err.forbidden": "Access denied.",
    "auth.err.invalid_credentials": "Wrong email or password.",
    "auth.err.email_in_use": "This email is already registered. Try signing in.",
    "auth.err.too_many_attempts": "Too many failed attempts. Please retry in 15 minutes.",
    "auth.err.invalid_email_format": "Invalid email address. Use a valid domain (e.g. gmail.com).",
    "auth.err.validation_error": "Some fields are invalid. Please review and retry.",
    "auth.err.missing_refresh_token": "Session expired. Please sign in again.",
    "auth.err.invalid_token": "Invalid session. Please sign in again.",
    "auth.err.user_not_found": "Account not found.",
    "auth.err.invalid_reset_token": "Reset link is invalid or already used.",
    "auth.err.reset_token_expired": "This reset link has expired.",
    "auth.err.no_password_set": "This account uses Google. Please sign in with Google.",
    "auth.err.wrong_current_password": "Current password is incorrect.",
    "auth.err.invalid_google_session": "The Google session is invalid or expired.",
    "auth.success.login": "Signed in successfully.",
    "auth.success.register": "Account created successfully.",

    "dashboard.hello": "Hello",
    "dashboard.stats.games": "Games played", "dashboard.stats.wins": "Wins",
    "dashboard.stats.best": "Best score", "dashboard.stats.avg": "Average score",
    "dashboard.recent": "Recent games", "dashboard.leaderboard": "Global leaderboard",
    "dashboard.actions.play": "New game", "dashboard.actions.join": "Join game",
    "dashboard.progress": "Progression", "dashboard.level": "Level", "dashboard.xp": "Experience",
    "dashboard.noGames": "No games yet. Start your first!",

    "lobby.title": "Lobby",
    "lobby.subtitle": "Create a game or join an existing one.",
    "lobby.create.title": "Create a game", "lobby.create.public": "Public",
    "lobby.create.private": "Private (with code)", "lobby.create.language": "Language",
    "lobby.create.button": "Create", "lobby.open": "Open games",
    "lobby.join": "Join", "lobby.joinCode": "Invite code",
    "lobby.joinCode.button": "Join with code",
    "lobby.bot.title": "Play against Coach Globo",
    "lobby.bot.difficulty": "Difficulty",
    "lobby.bot.easy": "Easy", "lobby.bot.medium": "Medium", "lobby.bot.hard": "Hard",
    "lobby.bot.start": "Start bot game",

    "game.turn": "Your turn", "game.opponent": "Opponent's turn",
    "game.waiting": "Waiting for opponent...", "game.invite": "Invite code",
    "game.pass": "Pass", "game.play": "Play word", "game.exchange": "Exchange",
    "game.forfeit": "Forfeit", "game.recall": "Recall tiles", "game.shuffle": "Shuffle",
    "game.bag": "Bag", "game.score": "Score", "game.over": "Game over",
    "game.winner": "Winner", "game.draw": "Draw", "game.forfeitConfirm": "Confirm forfeit?",

    "history.title": "Game history", "history.empty": "No games in your history.",
    "history.date": "Date", "history.opponent": "Opponent",
    "history.result": "Result", "history.score": "Score",
    "history.won": "Win", "history.lost": "Loss", "history.draw": "Draw", "history.abandoned": "Abandoned",

    "lb.title": "Leaderboards",
    "lb.period.all": "All time", "lb.period.week": "Week",
    "lb.period.month": "Month", "lb.period.year": "Year",
    "lb.scope.global": "Global", "lb.scope.org": "Organization", "lb.scope.country": "Country",
    "lb.rank": "Rank", "lb.player": "Player", "lb.wins": "Wins",
    "lb.games": "Games", "lb.best": "Best", "lb.total": "Total",

    "stats.title": "Personal statistics",
    "stats.progression": "Progression (last 10)",
    "stats.winRate": "Win rate",

    "rewards.title": "Rewards", "rewards.subtitle": "Track your progress and achievements.",
    "rewards.unlocked": "Unlocked", "rewards.locked": "Locked", "rewards.progress": "Progress",

    "profile.title": "Profile & Settings", "profile.personal": "Personal information",
    "profile.language": "Language", "profile.theme": "Theme",
    "profile.theme.light": "Light", "profile.theme.dark": "Dark", "profile.theme.system": "System",
    "profile.org": "Organization / School", "profile.country": "Country",
    "profile.save": "Save", "profile.password": "Security",
    "profile.password.current": "Current password", "profile.password.new": "New password",
    "profile.password.update": "Update", "profile.danger": "Danger zone",
    "profile.delete": "Delete my account", "profile.deleteConfirm": "Permanently delete your account?",
    "profile.notif.enable": "Enable push notifications",
    "profile.notif.test": "Send test notification",
    "profile.notif.denied": "Permission denied by browser",

    "notif.title": "Notifications", "notif.empty": "No notifications.",
    "notif.markAllRead": "Mark all as read",

    "admin.title": "Administration", "admin.overview": "Overview",
    "admin.users": "Users", "admin.games": "Games", "admin.logs": "Logs",
    "admin.announcement": "Announcement", "admin.settings": "Settings",
    "admin.broadcast": "Broadcast to all",
    "admin.title.field": "Title", "admin.body.field": "Message",
    "admin.send": "Send", "admin.role": "Role", "admin.ban": "Ban", "admin.delete": "Delete",
    "admin.turnSeconds": "Turn duration (seconds)", "admin.save": "Save",

    "common.loading": "Loading...", "common.save": "Save", "common.cancel": "Cancel",
    "common.confirm": "Confirm", "common.delete": "Delete", "common.close": "Close",
    "common.search": "Search", "common.error": "Error", "common.success": "Success",
    "common.optional": "Optional", "common.brand": "Globo",
    "common.brandLong": "Globo — The Game of Emergence",
    "common.company": "CBC Global Holdings Ltd",
    "common.next": "Next", "common.prev": "Previous",

    "onb.step1.title": "Welcome to Globo",
    "onb.step1.body": "Globo — The Game of Emergence is an educational platform where every game reveals a bit more intelligence. Take 30 seconds to discover how it works.",
    "onb.step2.title": "One game, many benefits",
    "onb.step2.body": "Enrich your vocabulary, sharpen your strategy and compete with players around the world — rankings by school, university or organization.",
    "onb.step3.title": "Ready to play?",
    "onb.step3.body": "Choose where to start. You can always come back here from the Help Center.",
    "onb.next": "Continue", "onb.done": "Let's go",
    "onb.cta.discover": "Discover Globo", "onb.cta.discoverBody": "Interactive step-by-step tutorial",
    "onb.cta.demo": "Watch demo", "onb.cta.demoBody": "A commented automatic game",
    "onb.cta.play": "Play now", "onb.cta.playBody": "Straight into the action",

    "tut.badge": "Interactive tutorial", "tut.title": "Learn Globo", "tut.skip": "Skip",
    "tut.stepLabel": "Step {n} / {total}", "tut.finish": "Finish",
    "tut.step.board.title": "The official board",
    "tut.step.board.body": "The Globo board has 9 columns and 6 rows. Top 3 rows show the alphabet upright; bottom 3 rows are rotated 180° so each player sees their side upright.",
    "tut.step.letters.title": "Engraved letters",
    "tut.step.letters.body": "Each cell has a printed letter. They serve as visual markers — letter value depends on frequency (A, E, I = 1 pt; K, W, X = 10 pts).",
    "tut.step.numbers.title": "Numbers 1 to 9",
    "tut.step.numbers.body": "Top and bottom edges number columns 1–9. Handy to describe positions and think about column values.",
    "tut.step.zones.title": "The Emergence Zone",
    "tut.step.zones.body": "At the board's center, the Emergence Zone — highlighted in cyan — grants a double-word bonus. Every game starts here.",
    "tut.step.turn.title": "A turn",
    "tut.step.turn.body": "You have 40 seconds. Pick a letter from your rack, click a cell. Try it now: place CAT across the center.",
    "tut.step.score.title": "Score calculation",
    "tut.step.score.body": "Each letter has a value. TW/DW multiply the word; TL/DL multiply a letter. Use all 7 tiles at once for a +50 Bingo!",
    "tut.step.end.title": "End of the game",
    "tut.step.end.body": "Game ends when a player empties their rack (and the bag is empty), or after several consecutive passes. The winner earns XP and badges.",
    "tut.action.placeCat": "Click C, then (2,3); A → (2,4); T → (2,5).",
    "tut.action.placedCount": "letters placed",

    "demo.badge": "Demonstration", "demo.title": "A live game",
    "demo.progress": "Progress", "demo.lastMove": "Last move", "demo.starting": "Game start",
    "demo.intro": "Léa vs. Kofi. Watch how each move chains and scores.",
    "demo.play": "Play", "demo.pause": "Pause",
    "demo.next": "Next", "demo.back": "Back", "demo.restart": "Replay",
    "demo.done.title": "You watched it all!",
    "demo.done.replay": "Watch again", "demo.done.tutorial": "Try the tutorial", "demo.done.play": "Play a game",

    "coach.name": "Coach Globo", "coach.online": "Online",
    "coach.placeholder": "Ask a question…",
    "coach.q.rules": "The rules", "coach.q.scores": "How do I score?", "coach.q.play": "How to play?",
    "coach.greet.default": "Hello {name}! I'm Coach Globo.",
    "coach.greet.dashboard": "Good to see you {name}. Ready for another game? Check your stats below.",
    "coach.greet.lobby": "Create a public/private game or join a waiting opponent.",
    "coach.greet.game": "Game on! Pick a letter, then click a free cell. Good luck.",
    "coach.greet.lb": "Rankings — filter by period and scope.",
    "coach.greet.stats": "Your personal stats over the last 10 games.",
    "coach.greet.rewards": "Each badge unlocks with an action.",
    "coach.greet.tutorial": "Let's do the tutorial together.",
    "coach.greet.demo": "Watch this scripted match — every move is explained.",
    "coach.a.rules": "Place letters to form valid words. First move crosses the center; later moves connect to existing words. 40s per turn.",
    "coach.a.scores": "Sum letter values. Special cells multiply a word (TW/DW) or a letter (TL/DL). Bingo = +50 pts for using all 7 tiles.",
    "coach.a.board": "9 columns × 6 rows. Center is the Emergence Zone — required for the first move.",
    "coach.a.blank": "The blank (?) is worth 0 pts and can be any letter you choose.",
    "coach.a.bonus": "The Emergence Zone grants a double-word bonus. Other cells are placed symmetrically.",
    "coach.a.rewards": "Each badge is a milestone in Rewards. XP grows your level.",
    "coach.a.timer": "40 seconds per turn. Timeout = auto-pass.",
    "coach.a.pass": "You can pass anytime. If both players pass twice in a row, the game ends.",
    "coach.a.pwa": "You can install Globo like a native app — look for \"Install app\" in your browser menu.",
    "coach.a.default": "I'm here to guide you. Try: \"How to play?\", or open the Help Center.",

    "help.badge": "Help Center", "help.title": "How can we help?",
    "help.subtitle": "Everything you need to get started and improve.",
    "help.searchPlaceholder": "Search a rule, tip, question…",
    "help.quick.tutorial": "Tutorial", "help.quick.demo": "Demo",
    "help.quick.play": "Play", "help.quick.coach": "Coach Globo",
    "help.section.rules": "Game rules", "help.section.scoring": "Scoring", "help.section.faq": "FAQ",
    "help.rules.q1": "How do I start a game?",
    "help.rules.a1": "From Play, create a public or private game. Once an opponent joins, the game starts automatically.",
    "help.rules.q2": "Does the first word need to cross the center?",
    "help.rules.a2": "Yes. One of the placed letters must occupy the center cell.",
    "help.rules.q3": "How long do I have per turn?",
    "help.rules.a3": "40 seconds. After that, the turn is auto-passed.",
    "help.rules.q4": "Can I exchange letters?",
    "help.rules.a4": "Yes, if the bag has enough letters. It counts as a passed turn.",
    "help.rules.q5": "When does the game end?",
    "help.rules.a5": "When a player empties their rack (bag empty), or after 4 consecutive passes.",
    "help.scoring.q1": "How are letter values computed?",
    "help.scoring.a1": "AEILNORSTU=1; DGM=2; BCP=3; FHV=4; JQ=8; KWXYZ=10; blank=0.",
    "help.scoring.q2": "What is a cell bonus?",
    "help.scoring.a2": "TW ×3, DW ×2 (word). TL ×3, DL ×2 (letter). Each applies once when a tile is first placed.",
    "help.scoring.q3": "What is a Bingo?", "help.scoring.a3": "Using all 7 tiles in one move = +50 points.",
    "help.scoring.q4": "How does XP work?",
    "help.scoring.a4": "30 XP base + 1 per 10 points + 50 for a win. XP raises your level.",
    "help.faq.q1": "Can I install Globo as an app?",
    "help.faq.a1": "Yes. Click \"Install Globo\" when the banner appears, or \"Add to Home Screen\" from your browser.",
    "help.faq.q2": "Does Globo work offline?",
    "help.faq.a2": "Last visited screen is available offline. Live games require Internet.",
    "help.faq.q3": "How do I change the language?", "help.faq.a3": "Click FR/EN in the top bar, or from your profile.",
    "help.faq.q4": "How do I join my school leaderboard?",
    "help.faq.a4": "Fill in your school in your profile. You'll appear automatically in that organization's ranking.",
    "help.faq.q5": "How does Coach Globo work?",
    "help.faq.a5": "The Coach answers rule questions and adapts to your current page. Click the floating icon.",

    "pg.title": "Game analysis", "pg.wordsPlayed": "Words played",
    "pg.bestWord": "Best word", "pg.avgPerWord": "Avg. per word",
    "pg.evolution": "Compared to your average",
    "pg.strengths": "Strengths", "pg.improve": "Areas to improve",
    "pg.tip.longWords": "Longer words multiply bonuses.",
    "pg.tip.center": "Crossing an Emergence Zone doubles your score.",
    "pg.tip.bingo": "Use all 7 tiles for the +50 Bingo bonus.",
    "pg.tip.regular": "Play regularly to climb the leaderboards.",
    "pg.rematch": "Rematch", "pg.share": "Share",

    "nav.help": "Help", "nav.tutorial": "Tutorial", "nav.demo": "Demo",
    "assist.firstMove": "First move: place a tile on the center square (W), then build the word around it.",
    "assist.selectTile": "Pick a letter from your rack below, then click an empty cell.",
    "assist.playWord": "Click \"Play word\" to submit, or \"Recall\" to undo.",
    "assist.wait": "Wait for your opponent to play.",
  },
};
